































































































































































































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";
import {Device, Player, PlayerColor, PlayersData, PlayerState} from "../../../types";
import DateHelper from "../../helpers/DateHelper";
import Clipboard from 'v-clipboard';
import MessageHelper from "../../helpers/MessageHelper";
Vue.use(Clipboard);
// @ts-ignore
import Tools from "../../helpers/Tools";
import EventApi from "../../api/EventsApi";
import {Tool} from "../../helpers/Tool";
import ClickEvent = JQuery.ClickEvent;

@Component({
    components: {},
    props: {
        seatsMap: {
            type: Object,
            required: true
        },
        playerId: {
            type: String,
            required: true
        },
        availableColors: {
            type: Array,
            required: true
        },
        devices: {
            type: Array,
            required: true
        },
        gameRestrictions: {
            type: Object,
            required: true
        },
    }
})

export default class SettingsModal extends Vue {
    private seatsMap!: {[key: string]: PlayerState|null};
    private playerId!: string;
    private availableColors!: Array<PlayerColor>;
    private camsAreVisible: boolean = false;
    private micsAreVisible: boolean = false;
    private devices!: Array<Device>;
    private chosenSeat: number|null = null;
    private notChangedColor: boolean = true;
    private modalCameraState: boolean = false;
    private modalMicState: boolean = false;
    private localVideoElement: HTMLVideoElement|null = null;
    private localVideoElementWrapper: HTMLVideoElement|null = null;
    private typingName: string = '';
    private settingsUserOn: boolean = true;
    private gameRestrictions!: any;
    private switcherWidth: string = '';
    private readonly ic_change = '/images/ic_change.png';
    private urlRoom: string = '';
    private settingsComment: string = '';
    private codeEntered: boolean = false;
    private roomFreeze: boolean = false;
    private codeRoom: string = '';
    private isCommentSettings: boolean = false;
    private commentSettings: string = 'The next party time is 21 july at 9:00 p.m';

    private colorNames: Array<string> = [
        // @ts-ignore
        this.$t('color.green'), this.$t('color.red'), this.$t('color.blue'), this.$t('color.yellow'), this.$t('color.mint'), this.$t('color.purple')
    ];

    private allowCloseWindow: boolean = false;

    mounted(): void
    {
        Vue.nextTick(() => {
            if (!this.conferenceIsAllowed) {
                return;
            }
            this.localVideoElement = this.$refs.userVideoPreview as HTMLVideoElement;
            this.localVideoElementWrapper = this.$refs.userVideoPreviewWrapper as HTMLVideoElement;
            if (this.localVideoElementWrapper) {
                this.$conferenceManager.devicesManager.getLocalMedia(this.localVideoElementWrapper).then(() => {
                    this.typingName = this.playerName.toString();
                    this.modalCameraState = JSON.parse(JSON.stringify(this.cameraIsOn));
                    this.modalMicState = JSON.parse(JSON.stringify(this.micIsOn));
                    this.urlRoom = window.location.href;

                    setTimeout(() => {
                        this.allowCloseWindow = true;
                    }, 1000);
                });
            }
        });
    }
    updated(): void
    {
        this.getSwitcherWidth();
    }

    /**
     * Ширина активного эл-та свитчера
     */
    private getSwitcherWidth(): void
    {
        const user = this.$refs.settings_user as HTMLElement;
        const room = this.$refs.settings_room as HTMLElement;
        if (typeof user !== 'undefined') {
            if (this.settingsUserOn ) {
                this.switcherWidth = user.offsetWidth + 'px';
            } else {
                this.switcherWidth = room.offsetWidth + 'px';
            }
        }
    }

    /**
     * Разрешена инициализация конференции
     * @private
     */
    private get conferenceIsAllowed(): boolean
    {
        return store.getters.getConferenceIsAllowed;
    }

    private get currentLang(): string
    {
        return document.documentElement.lang;
    }

    /**
     * Текущий статус микрофона в рамках сессии
     */
    private get micIsOn(): null|boolean
    {
        return store.getters.getMicrophoneStatus;
    }

    /**
     * Текущий статус камеры в рамках сессии
     */
    private get cameraIsOn(): boolean
    {
        return store.getters.getCameraStatus;
    }

    /**
     * Статус подключения игрока (guest, active, pending)
     */
    private get playerConnectionStatus(): string
    {
        return store.getters.getPlayerConnectionStatus;
    }

    /**
     * Является гостем
     */
    private get isGuest(): boolean
    {
        return this.playerConnectionStatus === 'guest';
    }

    /**
     * все игроки
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * текущий игрок
     */
    private get player(): Player|null
    {
        const filtered = this.players.filter(player => player.id === this.playerId);

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }

        return null;
    }

    /**
     * Текущее название цвета
     */
    private get currentColorName(): string
    {
        if (this.currentPlayerData && this.notChangedColor) {
            return this.currentPlayerData.color.name;
        }
        if (Number.isInteger(this.chosenSeat)) {
            return this.getColorName(this.chosenSeat as number);
        }
        return '';
    }

    /**
     * Данные об игроках
     */
    private get playersData(): PlayersData
    {
        return store.getters.getGameState.playersData;
    }

    /**
     * Название активной камеры
     */
    private get activeCamName(): string
    {
        let name = '';

        const filtered = this.camsList.filter(cam => cam.isActive);

        if (typeof filtered[0] !== 'undefined') {
            name = filtered[0].name;
        }

        return name;
    }

    /**
     * Название активной камеры
     */
    private get activeMicName(): string
    {
        let name = '';

        const filtered = this.micsList.filter(mic => mic.isActive);

        if (typeof filtered[0] !== 'undefined') {
            name = filtered[0].name;
        }

        return name;
    }

    /**
     * Список камер
     */
    private get camsList(): Array<Device>
    {
        return this.devices.filter(item => item.type === 'camera');
    }

    /**
     * Список микрофонов
     */
    private get micsList(): Array<Device>
    {
        return this.devices.filter(item => item.type === 'microphone');
    }

    /**
     * Текущий игрок
     */
    private get currentPlayerData(): any
    {
        let data = null;

        for (let index in this.seatsMap) {
            if (this.seatsMap[index] && (this.seatsMap[index] as PlayerState).id === this.playerId) {
                data = this.seatsMap[index];
            }
        }

        return data;
    }

    /**
     * Имя игрока
     */
    private get playerName(): string
    {
        let playerData = this.getPlayerData();

        if (!playerData) {
            return '';
        }

        if (this.player && !this.player.hasCustomName) {
            return this.currentColorName;
        }

        return playerData.name;
    }

    /**
     * Название цвета
     * @param index
     * @return {string|null}
     */
    private getColorName(index: number): string
    {
        if (typeof this.availableColors[index] === "undefined") {
            return '';
        }
        return this.availableColors[index].name;
    }

    /**
     * Изменить имя игрока
     */
    private changePlayerName(name: string): void
    {
        this.typingName = name;
        // @ts-ignore
        Tools.runTimer('changePlayerName', () => {
            const data = {
                playerId: this.playerId,
                name: name
            };
            MessageHelper.changePlayerNameMessage(data);
        });
    }

    /**
     * Данные игрока
     * @return {null|*}
     */
    private getPlayerData(): any
    {
        if (typeof store.getters.getGameState.playersData === "undefined") {
            return null;
        }

        let playersData = store.getters.getGameState.playersData;

        if (typeof playersData[this.playerId] === "undefined") {
            return null;
        }

        return playersData[this.playerId];
    }

    /**
     * Цвет сита
     * @param seat
     * @return {string|*}
     */
    private getSeatColorData(seat: number): {[key: string]: any}|null
    {
        if (typeof this.availableColors[seat] === 'undefined') {
            return null;
        }
        return this.availableColors[seat];
    }

    /**
     * Класс для подложки сита
     * @param seat
     * @return {string|*}
     */
    private getSeatColorBackgroundClass(seat: number): string
    {
        let name = '';
        if (this.currentPlayerData && this.notChangedColor) {
            name = this.currentPlayerData.color.name;
        } else {
            const data = this.getSeatColorData(seat);
            if (!data) {
                return '';
            }
            name = data.name;
        }

        switch (name) {
            // @ts-ignore
            case this.$t('color.green'):
                return 'green';
            // @ts-ignore
            case this.$t('color.red'):
                return 'red';
            // @ts-ignore
            case this.$t('color.blue'):
                return 'blue';
            // @ts-ignore
            case this.$t('color.yellow'):
                return 'yellow';
            // @ts-ignore
            case this.$t('color.mint'):
                return 'brown';
            // @ts-ignore
            case this.$t('color.purple'):
                return 'violet';
            default:
                return '';
        }
    }

    /**
     * Класс для подложки сита
     * @param name
     * @return {string|*}
     */
    private getSeatColorBackgroundImage(name: number): string
    {
        switch (name) {
            // @ts-ignore
            case this.$t('color.green'):
                return 'url("/images/players/player-green.png")';
            // @ts-ignore
            case this.$t('color.red'):
                return 'url("/images/players/player-red.png")';
            // @ts-ignore
            case this.$t('color.blue'):
                return 'url("/images/players/player-blue.png")';
            // @ts-ignore
            case this.$t('color.yellow'):
                return 'url("/images/players/player-yellow.png")';
            // @ts-ignore
            case this.$t('color.mint'):
                return 'url("/images/players/player-brown.png")';
            // @ts-ignore
            case this.$t('color.purple'):
                return 'url("/images/players/player-violet.png")';
            default:
                return '';
        }
    }

    private getSeatColorBackgroundClassWithoutData(color: string): string
    {
        switch (color) {
            // @ts-ignore
            case this.$t('color.green'):
                return 'green';
            // @ts-ignore
            case this.$t('color.red'):
                return 'red';
            // @ts-ignore
            case this.$t('color.blue'):
                return 'blue';
            // @ts-ignore
            case this.$t('color.yellow'):
                return 'yellow';
            // @ts-ignore
            case this.$t('color.mint'):
                return 'brown';
            // @ts-ignore
            case this.$t('color.purple'):
                return 'violet';
            default:
                return '';
        }
    }

    private toggleSettingsTab(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        if (this.settingsUserOn) {
            Tool.endUpdateGameStateTimer();
        } else {
            MessageHelper.getState();
            Tool.startUpdateGameStateTimer(60000);
        }
    }

    /**
     * Показать/скрыть список камер
     * @private
     */
    private toggleCamsList(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.camsAreVisible = !this.camsAreVisible;
    }

    /**
     * скрыть список камер
     * @private
     */
    private closeCamsList(): void
    {
        this.camsAreVisible = false;
    }

    /**
     * Показать/скрыть список камер
     * @private
     */
    private toggleMicsList(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.micsAreVisible = !this.micsAreVisible;
    }

    /**
     * скрыть список камер
     * @private
     */
    private closeMicsList(): void
    {
        this.micsAreVisible = false;
    }

    /**
     * изменить цвет сита
     * @private
     */
    private takeSeat(e: ClickEvent): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        const color = this.availableColors.length && Number.isInteger(this.chosenSeat)
            ? this.availableColors[this.chosenSeat as number].code
            : this.currentPlayerData.color.code;
        this.$emit('save-settings', {
            camera: this.modalCameraState,
            microphone: this.modalMicState,
            color: color
        });
        this.closeModal(e,true);
    }

    /**
     * Изменить цвет сита
     */
    private changeColor(seat: number): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.chosenSeat = seat;
        this.notChangedColor = false;
        if (this.colorNames.includes(this.playerName)) {
            this.typingName = this.playerName.toString();
        }
    }

    /**
     * Изменить девайс
     * @param type
     * @param id
     * @private
     */
    private changeDevice(type: string, id: string): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('change-device', {type: type, id: id, localVideoElement: this.localVideoElement});
        this.closeCamsList();
        this.closeMicsList();
    }

    /**
     * Закрыть модалку
     */
    private closeModal(e: ClickEvent, saveSettings = false): void
    {
        EventApi.triggerEvent(EventApi.CLOSE_SETTINGS_MODAL);
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('close-modal', saveSettings);
    }

    /**
     * Вкл/выкл камеру
     * @private
     */
    private changeCameraStatus(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.modalCameraState = !this.modalCameraState;
    }

    /**
     * Вкл/выкл микрофон
     * @private
     */
    private changeMicrophoneStatus(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.modalMicState = !this.modalMicState;
    }

    /**
     * Выделить текст в текстовом поле
     * @private
     */
    private selectText(e: Event): void
    {
        const textField = e.target as HTMLInputElement || HTMLTextAreaElement;
        textField.select();
    }

    /**
     * Время жизни комнаты
     * @returns {string}
     */
    private get getRoomLifetime(): string
    {
        return DateHelper.secondsToDate(this.gameRestrictions.lifetime);
    }

    private successCopy(): void
    {
        const urlInput = this.$refs.urlInput as HTMLElement;
        urlInput.classList.add('tooltip');
        setTimeout(function () {
            urlInput.classList.remove('tooltip')
        }, 3000);
    }
}

